import md5 from 'js-md5'
import CryptoJS from 'crypto-js/crypto-js'

//日期扩展format
Date.prototype.format = function(fmt) { 
    var o = { 
       "M+" : this.getMonth()+1,                 //月份 
       "d+" : this.getDate(),                    //日 
       "h+" : this.getHours(),                   //小时 
       "m+" : this.getMinutes(),                 //分 
       "s+" : this.getSeconds(),                 //秒 
       "q+" : Math.floor((this.getMonth()+3)/3), //季度 
       "S"  : this.getMilliseconds()             //毫秒 
   }; 
   if(/(y+)/.test(fmt)) {
           fmt=fmt.replace(RegExp.$1, (this.getFullYear()+"").substr(4 - RegExp.$1.length)); 
   }
    for(var k in o) {
       if(new RegExp("("+ k +")").test(fmt)){
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
        }
    }
   return fmt; 
}

// 默认的 KEY 与 iv 如果没有给
const KEY = CryptoJS.enc.Utf8.parse("6215086662150866");
const IV = CryptoJS.enc.Utf8.parse('6215086662150866');

const commonFn={
    pwd99:function(data){
        if(!data) return null
        let password = data
        for (let i = 0; i < 99; i++) {
            password = md5(password); 
        }
        return password
    },
    //存储
    setStorage:function(key,data){
        if(!key) return;
        if(typeof data=='object'){
            data=JSON.stringify(data);
        }
        window.sessionStorage.setItem(key,data)
    },
    //获取存储的对象值
    getStorage:function(key){
        if(!key) return;
        let data=window.sessionStorage.getItem(key);
        return JSON.parse(data);
    },
    //获取存储的字符串的值
    getStorageS:function(key){
        return window.sessionStorage.getItem(key);
    },
    //移出全部存储
    removeStorage:function(){
        window.sessionStorage.clear();
    },
    //获取日期
    getAllDate() {
        var date = new Date();
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var day = date.getDate();
        if (month < 10) {
            month = '0' + month;
        }
        if (day < 10) {
            day = '0' + day;
        }
        return year + month + day;
    },
    //获得时间
    getTime() {
        var date = new Date();
        return date.getTime()
    },
    //日期格式化(原始数据，格式样式[yyyy-MM-dd])
    format(data,rule){
        return new Date(data).format(rule);
    },
    getConsole(msg,ret){
        console.log(msg+'————————');
        console.log(ret);
    },
    exportMax(count){
        if(count>2000){
            alert("当前数据大于2000条，请筛选后再操作！")
            return true;
        }
        return false;
    },
    //ase加密
    Encrypt(word, keyStr, ivStr) {
        let key = KEY
        let iv = IV
      
        if (keyStr) {
          key = CryptoJS.enc.Utf8.parse(keyStr);
          iv = CryptoJS.enc.Utf8.parse(ivStr);
        }
      
        let srcs = CryptoJS.enc.Utf8.parse(word);
        var encrypted = CryptoJS.AES.encrypt(srcs, key, {
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.ZeroPadding
        });
       // console.log("-=-=-=-", encrypted.ciphertext)
        return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
      
    },
    //ase解密
    Decrypt(word, keyStr, ivStr) {
        let key  = KEY
        let iv = IV
        
        if (keyStr) {
            key = CryptoJS.enc.Utf8.parse(keyStr);
            iv = CryptoJS.enc.Utf8.parse(ivStr);
        }
        
        let base64 = CryptoJS.enc.Base64.parse(word);
        let src = CryptoJS.enc.Base64.stringify(base64);
        
        var decrypt = CryptoJS.AES.decrypt(src, key, {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.ZeroPadding
        });
        
        var decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
        return decryptedStr.toString();
    }
}

export default commonFn

export const isMoney=function(data){
    const reg = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/;
    return reg.test(data)
}

// 手机号验证
export const isvalidPhone=function(str) {
    const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
    return reg.test(str)
}
//固定电话或手机号验证
export const isvalidCallAndPhone=function(str){
    const reg=/^(1[3|4|5|6|7|8|9][0-9]\d{8}$)|(^0\d{2,3}-\d{7,8})$/
    return reg.test(str);
}


// WEBPACK FOOTER //
// ./src/service/common.js